import React from 'react';
import { Flex, Spinner } from '@patternfly/react-core';
import { useTranslation } from '../../../localization/useTranslation';
import './ChartPanel.scss';
import T from '../../../localization/LocalizationKeys';
import Icons, { Size } from '../../Common/Icons';
import ModelType from '../../Model/ModelType';
import _ from 'lodash';
import useInterval from '../../../utils/hooks/useInterval';
import AssetPropList from 'components/Asset/AssetPage/AssetPropList';

const DEFAULT_REFRESH_INTERVAL = 5; // 5 minutes
const MIN_REFRESH_INTERVAL = 5; // 5 minutes

const PropertyPanel = ({ data, api }) => {
  const reload = api.reload;
  const refreshInterval = data.propertyValues?.refreshInterval;
  const hasError = data.propertyValues?.hasError;
  const isLoading = data.propertyValues?.isLoading;
  useInterval(reload, Math.max(MIN_REFRESH_INTERVAL, (refreshInterval ?? DEFAULT_REFRESH_INTERVAL) * 60000));

  const T = useTranslation();
  const loadingDescription = hasError ? T.common.error.generic : T.common.loading;

  return (
    <div className={'chart-panel-container'}>
      { (isLoading || hasError) && <Flex alignItems={{ default: 'alignItemsCenter' }}>
        <Spinner size="md" />
        <span>{ loadingDescription }</span>
      </Flex> }
      <AssetPropList
        propModels={data.propertyValues?.assetModel?.properties}
        updateProps={data.propertyValues?.updateProps}
        isUpdatingProps={data.propertyValues?.isUpdatingProps}
        refetchReported={data.propertyValues?.refetchReported}
      />
    </div>
  );
};


PropertyPanel.info = {
  label: 'Property Panel',
  icon: <Icons.ChartLine size={Size.LARGE}/>,
  help: 'panels/proppanel'
};

PropertyPanel.properties = {
  propertyValues: {
    type: 'properties'
  }
};

PropertyPanel.models = [
  {
    path: 'refreshInterval',
    type: ModelType.NUMBER,
    label: T.common.refreshInterval,
    placeholder: _.toString(DEFAULT_REFRESH_INTERVAL)
  }
];

export default React.memo(PropertyPanel);
